import { NormalizedBusinessContext } from '@ravago/shared/page-data/models/contentful-mapped';

export class BusinessContextUtils {
   static isUSBusinessContext(businessContext: NormalizedBusinessContext | undefined | null) {
      if (!businessContext) return false;
      const businessContextName = businessContext.name.toLowerCase();
      return businessContextName.includes('entec') || businessContextName.includes('bamberger') || businessContextName.includes('channelpa');
   }

   static getContactEmail(businessContext: NormalizedBusinessContext | undefined | null, countryCode: string) {
      if (!businessContext) return false;

      const emailDomain = businessContext?.emailAddress?.split('@')[1] ?? '';
      const country = countryCode === 'GB' ? 'UK' : countryCode;

      return country === 'US' ? businessContext?.emailAddress : `ask.${country}@${emailDomain}`.toLowerCase();
   }
}
